import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-list-bubble-selector',
    templateUrl: './list-bubble-selector.component.html',
    styleUrls: ['./list-bubble-selector.component.css'],
    standalone: false,
})
export class ListBubbleSelectorComponent {
    @Input() elementList: any[];
    @Input() title: string;
    @Input() shouldDisable: boolean = false;
    @Input() listBubbleType: ListBubbleType = ListBubbleType.UNDEFINED;
    @Input() selectedElements: any[] = [];
    @Output() onElementSelected: EventEmitter<any[]> = new EventEmitter();

    shouldShowElements: boolean = true;

    showElements() {
        this.shouldShowElements = !this.shouldShowElements;
    }

    selectElement(element) {
        if (this.shouldDisable) {
            return;
        }
        const index = this.selectedElements.indexOf(element);
        if (index === -1) {
            this.selectedElements.push(element);
            this.onElementSelected.emit(this.selectedElements);
            return;
        }
        this.selectedElements.splice(index, 1);
        this.onElementSelected.emit(this.selectedElements);
    }

    elementIsSelected(element): boolean {
        return this.selectedElements.indexOf(element) !== -1;
    }

    clearSelectedElements() {
        this.selectedElements = [];
    }

    isCategoryList() {
        return this.listBubbleType === ListBubbleType.CATEGORY;
    }

    isGroupList() {
        return this.listBubbleType === ListBubbleType.GROUP;
    }

    isTypeList() {
        return this.listBubbleType === ListBubbleType.TYPE;
    }
}

export enum ListBubbleType {
    UNDEFINED = 'undefined',
    GROUP = 'group',
    CATEGORY = 'category',
    TYPE = 'type',
}
